"use strict";

/**
 * Returns the lower case version of a string.
 *
 * @param {String} str The string to lower case.
 * @return {String} The lower case version of `str`.
 * @example
 *
 *      toLower('XYZ'); //=> 'xyz'
 */
module.exports = function (str) {
  if (str === void 0) {
    str = '';
  }
  return str.toLowerCase();
};